import { result, set } from 'libraries/lodash'

export const toAssociatedResourceCA = function ({
  caSource,
  caEmailDays,
  caEmails
}) {
  const source = result(JSON.parse(caSource), 'results[0]')
  const content = {
    enabled: caEmails,
    mon: caEmailDays.indexOf(1) > -1,
    tue: caEmailDays.indexOf(2) > -1,
    wed: caEmailDays.indexOf(3) > -1,
    thu: caEmailDays.indexOf(4) > -1,
    fri: caEmailDays.indexOf(5) > -1
  }
  set(source, 'content.content', JSON.stringify(content))
  return source
}

export const toAssociatedResourceAnnotation = function ({
  id,
  commentReference: reference,
  commentTarget, commentCategory: category,
  body,
  privacy,
  owner,
  active,
  aol
}) {
  const target = `urn:esv:article:${aol}:${commentTarget}`
  const uri = `urn:esv:associated-resource:${id}`
  const content = JSON.stringify({
    reference,
    body,
    active,
    category
  })

  return {
    uri,
    party: {
      type: 'PartyRef',
      uri: owner
    },
    content: {
      content,
      uri,
      target,
      isPrivate: privacy === 'private'
    }
  }
}
